import React from "react";
import { ContentPage } from "@/components/ContentPage";

const sections = [
  {
    id: "story",
    heading: "Our Story",
    body: (
      <>
        <p>
          eBikeGo was born with a single conviction: everyday mobility in India
          should be electric, affordable and effortless. We started with a small
          fleet of electric scooters and a rider community obsessed with clean,
          reliable commutes. Today we're a nationwide EV rental platform serving
          daily commuters, delivery partners, students and enterprise fleets.
        </p>
        <p>
          As an <span className="font-semibold text-ink">EBG Group Company</span>,
          we bring decades of transport, logistics and technology expertise to
          every ride — engineered to feel simple.
        </p>
      </>
    ),
  },
  {
    id: "mission",
    heading: "Mission",
    body: (
      <p>
        Put a clean, connected two-wheeler within reach of every Indian rider —
        by the hour, day, week or month. No showrooms. No paperwork marathon.
        Just tap, ride and switch off fuel bills for good.
      </p>
    ),
  },
  {
    id: "fleet",
    heading: "The eBikeGo Fleet",
    body: (
      <p>
        We curate a 100% electric fleet across four categories — Electric
        Bicycles, Low Speed EV Scooters, High Speed EV Scooters and Electric
        Motorcycles. Every vehicle is inspected on a 47-point checklist before
        it reaches your doorstep, insured end-to-end and backed by 24×7
        roadside support.
      </p>
    ),
  },
  {
    id: "why",
    heading: "Why riders choose us",
    body: (
      <ul className="list-disc pl-5 space-y-2">
        <li>100% electric — zero fuel costs, zero tailpipe emissions.</li>
        <li>Doorstep delivery in every launch city.</li>
        <li>Insurance and 24×7 roadside assistance included in every plan.</li>
        <li>Flexible plans — hourly, daily, weekly or monthly.</li>
        <li>Verified and sanitised vehicles on every handover.</li>
      </ul>
    ),
  },
];

const About = () => (
  <ContentPage
    testId="about-page"
    eyebrow="About eBikeGo"
    title="Ride electric. Ride free."
    subtitle="We're building India's most trusted electric two-wheeler rental network — one clean, connected ride at a time."
    sections={sections}
  />
);

export default About;
